export default {
  "nav.spreadsheet": "Tabelle",
  "nav.categories": "Kategorien",
  "nav.guides": "Leitfäden",
  "nav.faq": "FAQ",
  "nav.home": "Startseite",
  "nav.visitMain": "Hauptwebsite besuchen",
  "nav.shoppingGuide": "Einkaufsführer",

  "hero.eyebrow": "Das Basetao Spreadsheet Ressourcen-Center",
  "hero.title": "Basetao Spreadsheet: Produkte, Verkäufer & Kaufleitfäden",
  "hero.subtitle": "Entdecke ausgewählte Produktkategorien, Verkäufer-Tipps und praktische Kaufleitfäden — alles übersichtlich an einem Ort.",
  "hero.cta1": "Basetao Spreadsheet",
  "hero.cta2": "Jetzt kaufen",
  "hero.note": "Alle Produktlinks öffnen sich auf der Hauptwebsite",

  "dropdown.label": "Kategorien durchsuchen",
  "dropdown.placeholder": "Produktkategorie auswählen",

  "categories.title": "Produktkategorien entdecken",
  "categories.subtitle": "Springe direkt zu den Produkten, die dich interessieren. Jede Kategorie öffnet eine gefilterte Liste auf der Hauptwebsite.",
  "categories.shoes": "Schuhe",
  "categories.hoodies": "Hoodies / Pullover",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jacken",
  "categories.pants": "Hosen / Shorts",
  "categories.headwear": "Kopfbedeckung",
  "categories.sets": "Sets",
  "categories.underwear": "Unterwäsche / Unterhosen",
  "categories.jersey": "Trikots",
  "categories.accessories": "Accessoires",
  "categories.bags": "Taschen",
  "categories.belts": "Gürtel",
  "categories.perfumes": "Parfums",
  "categories.other": "Weitere Artikel",
  "categories.viewAll": "Alles auf der Hauptwebsite ansehen",

  "about.title": "Was ist das Basetao Spreadsheet?",
  "about.p1": "Das Basetao Spreadsheet bündelt Produktlinks, Verkäufer-Notizen und Kauftipps in einem übersichtlichen Verzeichnis. Statt einen Artikel nach dem anderen zu suchen, erhältst du eine klare Übersicht jeder Kategorie — von Schuhen und Hoodies bis zu Taschen und Parfums.",
  "about.p2": "Jede Kategorie öffnet eine gefilterte Ansicht auf der Hauptwebsite, sodass du mit einem einzigen Klick von einer groben Idee zu einem konkreten Produkt gelangst. Das Ergebnis ist ein schnellerer und entspannterer Weg, genau das zu finden, was du suchst.",
  "about.p3": "Neben dem Verzeichnis veröffentlichen wir praktische Kaufleitfäden zu Verkäufern, Versand und Qualitätskontrolle — alle geschrieben, um dir mehr Sicherheit beim Einkaufen zu geben.",

  "guides.title": "Neueste Basetao Leitfäden",
  "guides.subtitle": "Praktische, originale Leitfäden zum sicheren Stöbern und Kaufen.",
  "guides.cardTitle": "Basetao Spreadsheet: Kompletter Leitfaden (2026)",
  "guides.cardDesc": "Erfahre, wie die Tabelle funktioniert, durchstöbere die Kategorien, finde zuverlässige Verkäufer und verstehe Versand und Qualitätskontrolle.",
  "guides.readArticle": "Vollständigen Leitfaden lesen",
  "guides.updated": "Aktualisiert Aug. 2026",
  "guides.badge": "Kaufleitfaden",

  "faq.title": "Häufig gestellte Fragen",
  "faq.subtitle": "Schnelle Antworten zum Basetao Spreadsheet und seiner Nutzung.",
  "faq.q1": "Was ist das Basetao Spreadsheet?",
  "faq.a1": "Es ist ein kuratiertes Verzeichnis aus Produktkategorien, Links und Kaufnotizen, das auf die Hauptwebsite verweist.",
  "faq.q2": "Wie durchsuche ich Produkte?",
  "faq.a2": "Nutze das Kategorie-Dropdown oder die Karten unten. Jede Option öffnet eine gefilterte Produktliste auf der Hauptwebsite.",
  "faq.q3": "Ist die Nutzung kostenlos?",
  "faq.a3": "Ja — das Durchsuchen des Verzeichnisses und das Lesen der Leitfäden ist kostenlos. Käufe werden auf der Hauptwebsite abgewickelt.",
  "faq.q4": "Wie kaufe ich etwas?",
  "faq.a4": "Wähle eine Kategorie, finde dein Produkt auf der Hauptwebsite und schließe dort den Kauf ab.",

  "cta.title": "Bereit, das Basetao Spreadsheet zu entdecken?",
  "cta.subtitle": "Durchsuche alle Kategorien an einem Ort und springe direkt zu den gewünschten Produkten.",
  "cta.primary": "Basetao Spreadsheet entdecken",
  "cta.secondary": "Hauptwebsite besuchen",

  "footer.disclaimer": "Diese Website ist eine unabhängige Informationsressource. Produktinformationen, Verkäufer, Preise und Verfügbarkeiten können sich ändern. Prüfe wichtige Details immer auf der Hauptwebsite, bevor du kaufst.",
  "footer.rights": "© 2026 Basetao Spreadsheet. Alle Rechte vorbehalten.",
  "footer.resources": "Ressourcen",
  "footer.explore": "Entdecken",
  "footer.home": "Startseite",
  "footer.guide": "Basetao Spreadsheet Leitfaden",
  "footer.categories": "Produktkategorien",
  "footer.visitMain": "Hauptwebsite besuchen",

  "article.notFound": "Artikel nicht gefunden",
  "article.notFoundDesc": "Der gesuchte Artikel existiert nicht oder wurde verschoben.",
};